// UnjustifiedAbsenceColumns.js
import React from 'react';
import memoize from 'memoize-one';
import { ButtonTooltip, DatatableEmployeeName, Icon } from '../../components';

const columns = memoize(clickHandler => [
  {
    name: 'TRABAJADOR',
    selector: 'employee_name',
    cell: item => (
      <DatatableEmployeeName item={item.employee} fileName="file_info" name="full_name" fileUrl="file_url" />
    ),
    sortable: true,
    grow: 0.7
  },
  {
    name: 'Fecha',
    selector: 'date',
    sortable: true,
    center: true,
    grow: 0.5
  },
  {
    name: 'Área',
    selector: 'employee_job_management',
    center: true,
    sortable: true,
    grow: 0.5
  },
  {
    name: 'Cargo',
    selector: 'employee_job_title',
    sortable: true,
    grow: 0.5
  },
  {
    name: 'Acciones',
    cell: item => (
      <>
        <ButtonTooltip
          onClick={() => clickHandler(item, 'show')}
          variant="circle-info"
          className="btn-circle"
          size="sm"
          text="Ver"
        >
          <Icon icon="eye" />
        </ButtonTooltip>

        {item.file_info && (
          <ButtonTooltip
            onClick={() => clickHandler(item, 'download')}
            variant="circle-primary"
            className="btn-circle"
            size="sm"
            text="Descargar"
          >
            <Icon icon="download-2" />
          </ButtonTooltip>
        )}

        <ButtonTooltip
          onClick={() => clickHandler(item, 'destroy')}
          variant="circle-danger"
          className="btn-circle"
          size="sm"
          text="Eliminar"
        >
          <Icon icon="trash" />
        </ButtonTooltip>
      </>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    center: true,
    width: '200px'
  }
]);

export default columns;
